import React from 'react';
import clsx from 'clsx';
import { Form } from 'react-bootstrap';

import type { ChangeHandler } from '../types/callbacks';

import './BayRangeSlider.scss';

export interface BayRangeSliderProps {
	min: number;
	max: number;
	label?: string | null;
	value: number;
	onChange: ChangeHandler<HTMLInputElement>;
	step?: number;
	disabled?: boolean;
	className?: string;
	formLabelClassName?: string;
	formRangeClassName?: string;
	style?: React.CSSProperties;
	variant?: string;
	[key: string]: any;
}

const BayRangeSlider: React.FC<BayRangeSliderProps> = ({
	min = 1,
	max = 4,
	label = null,
	value = 1,
	onChange,
	step = 1,
	disabled = false,
	className = '',
	formLabelClassName = '',
	formRangeClassName = '',
	style = {},
	variant = 'primary',
	...restProps
}) => {
	// NOTE: Calculate the percentage for the progress bar
	const range = max - min;
	const percentage = range
		? Math.max(0, Math.min(100, ((value - min) / range) * 100))
		: 0;

	return (
		<div className={clsx('bay-range-slider', className)}>
			{label && <Form.Label className={formLabelClassName}>{label}</Form.Label>}
			<Form.Range
				className={clsx(
					'bay-range-slider range-slider',
					formRangeClassName,
				)}
				disabled={disabled}
				max={max}
				min={min}
				step={step}
				style={{ '--range-progress': `${percentage}%`, ...style } as React.CSSProperties}
				value={value}
				onChange={onChange}
				{...restProps}
			/>
		</div>
	);
};

export default BayRangeSlider;
